export { default as FolderSolidIcon } from './FolderSolidIcon';
